import { OwnUpSmallBody } from '@rategravity/own-up-component-library';
import React from 'react';
import { WidgetWrapper } from '../common/WidgetWrapper';
import { monthlyMortgagePayments } from '../mortrage-lib/monthlyMortgagePayments';
import { DownPaymentProvider } from './data/dataProvider';
import { Inputs } from './inputs';
import { CalculationSummary } from './summary';

const description = (
  <React.Fragment>
    <OwnUpSmallBody variant="body1">
      Down Payment Calculator: Unlock Your Homeownership Journey
    </OwnUpSmallBody>
    <br />
    <OwnUpSmallBody variant="body1">
      Effortlessly compute your initial payment for a home purchase, helping you plan your budget
      and step closer to your dream home.
    </OwnUpSmallBody>
  </React.Fragment>
);

export const DownPaymentCalculator: React.FC = () => {
  console.log(
    'result: ',
    monthlyMortgagePayments({ loanAmount: 200000, interestRate: 6.6, termInYears: 30 })
  );
  return (
    <WidgetWrapper title="Down payment Calculator" description={description}>
      <DownPaymentProvider>
        <Inputs />
        <CalculationSummary />
      </DownPaymentProvider>
    </WidgetWrapper>
  );
};
